var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-close",
    x: 0.001,
    y: 0.001,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-close1",
    serifid: "iconB-close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.691,20.692c-0.411,0.411 -1.075,0.41 -1.486,0c-0,0 -7.205,-7.207 -7.205,-7.207l-7.207,7.207c-0.41,0.411 -1.075,0.411 -1.486,-0c-0.41,-0.411 -0.411,-1.075 0,-1.486c0,-0 7.208,-7.205 7.208,-7.205l-7.207,-7.207c-0.41,-0.41 -0.41,-1.075 0,-1.486c0.411,-0.411 1.075,-0.411 1.487,-0l7.205,7.208l7.206,-7.206c0.411,-0.411 1.076,-0.411 1.487,-0c0.41,0.41 0.411,1.075 -0,1.486l-7.208,7.205l7.205,7.205c0.414,0.408 0.414,1.078 0.001,1.486Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBClose);
export default __webpack_public_path__ + "static/media/iconB-close.94ce8055d0770036182ed0da31f60150.svg";
export { ForwardRef as ReactComponent };